const toFiniteNumber = (value) => {
  if (value == null || value === '') return null;
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
};

const monitoringFallbackAmount = (item) => {
  const hourlyRate = Number(item.hourlyRate) || 0;
  const hours = Number(item.activeHours) || 0;
  const monthlyTariff = Number(item.monthlyTariff) || 0;
  const customTotal = item.customTotal != null && Number.isFinite(Number(item.customTotal))
    ? Number(item.customTotal)
    : null;
  const base = customTotal != null ? customTotal : Math.ceil(hourlyRate * hours);
  if (monthlyTariff > 0) return Math.ceil(Math.min(base, monthlyTariff));
  return Math.ceil(base);
};

export const isCustomBillType = (billType) => {
  const type = String(billType || '').toLowerCase();
  return type === 'custom' || type === 'service';
};

export const getBillItemDisplay = (item, billType) => {
  const it = item && typeof item === 'object' ? item : {};
  const type = String(billType || '').toLowerCase();

  switch (type) {
    case 'custom':
    case 'service':
      return {
        label: String(it.name || it.description || it.device || ''),
        quantity: 1,
        amount: toFiniteNumber(it.amount ?? it.sum ?? it.total) ?? 0,
      };
    case 'subscription':
    case 'hoster_subscription':
      return {
        label: String(it.device || it.description || it.name || ''),
        quantity: toFiniteNumber(it.activeHours ?? it.hours),
        amount: toFiniteNumber(it.sum ?? it.total ?? it.amount) ?? 0,
      };
    case 'monitoring': {
      const sumRub = toFiniteNumber(it.sum);
      // Счёт по кВт·ч: в подписи позиции — расчётные кВт·ч
      const kwh = toFiniteNumber(it.kwh);
      return {
        label: [it.device || it.name || it.sn || '', kwh != null ? `${kwh.toLocaleString('ru-RU', { maximumFractionDigits: 2 })} кВт·ч` : ''].filter(Boolean).join(' · '),
        quantity: toFiniteNumber(it.activeHours ?? it.hours),
        amount: sumRub != null ? sumRub : monitoringFallbackAmount(it),
      };
    }
    default:
      return {
        label: String(it.name || it.device || it.sn || ''),
        quantity: toFiniteNumber(it.activeHours ?? it.hours ?? it.quantity),
        amount: toFiniteNumber(it.amount ?? it.sum ?? it.customTotal ?? it.total) ?? 0,
      };
  }
};

export const getBillItemsTotal = (items, billType, fallbackAmount) => {
  const list = Array.isArray(items) ? items : [];
  const fallback = toFiniteNumber(fallbackAmount) ?? 0;
  if (list.length === 0) return fallback;
  // Счёт по кВт·ч: итог — сумма счёта, она округлена до рубля и совпадает с PDF
  if (list.some((it) => toFiniteNumber(it?.kwh) != null) && fallback > 0) return fallback;
  const total = list.reduce((sum, it) => sum + getBillItemDisplay(it, billType).amount, 0);
  return total > 0 ? total : fallback;
};
